import {
    PaymentMethodResponse
} from '@/modules/configurationModule/detail/accounting/billable/payment-method/services/payment-method.dto'

export type PaymentMethodModalState = PaymentMethodResponse
export const initialPaymentMethodModalState =
    (): PaymentMethodResponse => ({
        id: -1,
        name: '',
        code: '',
        active: true
    })
